var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdecLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 97.217,
    height: 32.473,
    viewBox: "0 0 97.217 32.473",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_20",
    "data-name": "Group 20",
    transform: "translate(-88.015 -41.176)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2984",
    "data-name": "Group 2984",
    transform: "translate(88.015 41.176)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "White_Logo",
    "data-name": "White Logo",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Logo_with_Tagline",
    "data-name": "Logo with Tagline",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7",
    "data-name": "Group 7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    "data-name": "Group 5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M11.918,34.684V30.39a5.144,5.144,0,0,0-.42-2.455q-.423-.715-2.159-.717a4.61,4.61,0,0,0-2.158.418q-.775.418-.776.846,0,.288.553.86a1.986,1.986,0,0,1,.552,1.43,2.887,2.887,0,0,1-.916,2.138,3.165,3.165,0,0,1-2.3.89,3.107,3.107,0,0,1-2.182-.844A2.709,2.709,0,0,1,1.2,30.89q0-2.1,2.452-3.566a13.268,13.268,0,0,1,6.794-1.466,15.963,15.963,0,0,1,5.62.86q2.265.861,2.264,3.868V40.667q0,2.6,1.431,2.6a2.285,2.285,0,0,0,1.1-.453l.634,1.073a5.921,5.921,0,0,1-4.621,2.362q-2.745,0-4.6-2.886a9.759,9.759,0,0,1-6.829,2.886A5.639,5.639,0,0,1,1.454,44.9,4.394,4.394,0,0,1,0,41.545Q0,35.162,11.918,34.684Zm0,4.281V35.952a8.184,8.184,0,0,0-4.27.984,3.346,3.346,0,0,0-1.205,2.91A3.871,3.871,0,0,0,7.094,42.2a2.95,2.95,0,0,0,2.8.946,2.327,2.327,0,0,0,1.3-.819A5.612,5.612,0,0,0,11.918,38.964Z",
    transform: "translate(0 -14.022)",
    fill: "#0072ce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M100.174,0V30.179h2.289v.915H99.688a12.946,12.946,0,0,1-2.6.3l-2.6.155h-.728V28.806h-.089a4.757,4.757,0,0,1-4.516,3.09,6.468,6.468,0,0,1-5.206-2.921,11.528,11.528,0,0,1-2.235-7.215A10.362,10.362,0,0,1,83.99,14.9a6.709,6.709,0,0,1,5.262-2.724,5.792,5.792,0,0,1,4.514,2.352V1.8H90.1V.428h3.318q1.136,0,3.8-.213T100.174,0ZM93.766,24.134V19.17a7.113,7.113,0,0,0-1.052-4.283,2.863,2.863,0,0,0-2.168-1.4,1.47,1.47,0,0,0-1.337.994,10.9,10.9,0,0,0-.477,4.018v6.948a13.792,13.792,0,0,0,.352,3.879,1.3,1.3,0,0,0,1.282.995,3.3,3.3,0,0,0,2.189-1.293Q93.765,27.736,93.766,24.134Z",
    transform: "translate(-44.316)",
    fill: "#0072ce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M145.134,35.084H133.469v3.141a13.675,13.675,0,0,0,.651,5.108c.434.942,1.436,1.412,3,1.412a6.277,6.277,0,0,0,3.854-1.348,8.4,8.4,0,0,0,2.736-4.194h1.423a9.432,9.432,0,0,1-3.249,5.5,9.826,9.826,0,0,1-12.934-1.33,10.858,10.858,0,0,1-2.715-7.287,10.333,10.333,0,0,1,2.753-7.058,8.808,8.808,0,0,1,6.875-3.1,9.182,9.182,0,0,1,6.187,2.266Q144.683,30.455,145.134,35.084Zm-11.665-1.373H138.5V31.77q0-2.516-.694-3.27a2.435,2.435,0,0,0-1.884-.75,2.407,2.407,0,0,0-1.788.67q-.669.67-.669,3.4Z",
    transform: "translate(-68.457 -14.059)",
    fill: "#0072ce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M187.529,39.446h1.252a6.86,6.86,0,0,1-2.7,4.921,8.726,8.726,0,0,1-5.394,1.756,9.926,9.926,0,0,1-7.1-2.835,9.108,9.108,0,0,1-2.964-6.833,9.659,9.659,0,0,1,3.032-7.065,10.048,10.048,0,0,1,7.352-3.017A9.053,9.053,0,0,1,186.2,27.84a4.5,4.5,0,0,1,2.143,3.291,3.747,3.747,0,0,1-.782,2.591,3.144,3.144,0,0,1-2.417.967,3.05,3.05,0,0,1-2.205-.879,2.924,2.924,0,0,1-.91-2.193,2.457,2.457,0,0,1,1.207-2.381.775.775,0,0,0,.476-.645c0-.26-.256-.477-.773-.647a5.63,5.63,0,0,0-1.749-.254,3.051,3.051,0,0,0-2.612,1.227q-.91,1.223-.911,6.545,0,5.556.613,7.322t3.138,1.77Q186.05,44.553,187.529,39.446Z",
    transform: "translate(-92.527 -14.302)",
    fill: "#0072ce"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4",
    transform: "translate(11.457 3.616)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M32.149,18.787a1.786,1.786,0,0,1-.178-.557s1.668.164,2.67.164c1.261,0,1.878.014,2.192.017a.486.486,0,0,1,.542.537c-.02.363-.568.482-.568.482.531.03.592.03,1.288.022s1.156.005,1.321.008a.434.434,0,0,1,.449.493c0,.326-.465.433-.465.433s.373.03.9.031a2.672,2.672,0,0,1,.833.1c.14.056.353.162.332.414-.034.522-.538.462-.629.462a10.208,10.208,0,0,1-2.183-.157,1.58,1.58,0,0,1-.819-.692s-.525-.027-1.116-.044a3,3,0,0,1-1.238-.254,1.534,1.534,0,0,1-.493-.741s-.583,0-1.531-.088C32.257,19.3,32.149,18.787,32.149,18.787Z",
    transform: "translate(-28.794 -13.501)",
    fill: "#0072ce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M55.785,10.147c-1.7-.358-5.068-1.385-7.585-2.092-2.275-.635-3.233.745-3.8,2.732-.473,1.645-1.123,3.047-2.469,3.083-1.346-.035-1.995-1.437-2.468-3.083C38.9,8.8,37.939,7.42,35.663,8.055c-2.516.708-5.882,1.734-7.583,2.092a19.7,19.7,0,0,1-3.05.251s.422.77.921.956a7.954,7.954,0,0,0,3.545,0c1.775-.322,4.186-.939,4.792-1.066,2.094-.463,3.192.211,3.756,1.74a3.974,3.974,0,0,0,3.721,2.752H42.1a3.974,3.974,0,0,0,3.721-2.752c.564-1.529,1.662-2.2,3.757-1.74.6.127,3.017.744,4.792,1.066a7.952,7.952,0,0,0,3.544,0c.5-.186.921-.956.921-.956A19.685,19.685,0,0,1,55.785,10.147Z",
    transform: "translate(-25.03 -7.899)",
    fill: "#0072ce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M59.8,25.083a1.242,1.242,0,0,0-1.586.905c-.243,1.158,1.181,1.253,1.181,1.253s1.091.74-1.476,2.538c-.082.058-.408.217-.829.465v0c-.419-.246-.748-.41-.829-.467-2.568-1.8-1.477-2.538-1.477-2.538s1.425-.1,1.181-1.253a1.242,1.242,0,0,0-1.586-.905,2.394,2.394,0,0,0-1.43,2.737c.263,1.988,1.986,2.587,2.79,3.108.07.046.149.093.233.145a3.18,3.18,0,0,0-1.363,2.35,2.934,2.934,0,0,0,1.513,2.237,2.638,2.638,0,0,0-1.272,2.132,4.154,4.154,0,0,0,1.5,2.586,3.423,3.423,0,0,0-.88,2.264,4.633,4.633,0,0,0,1.441,2.8.849.849,0,0,0,.17.012.918.918,0,0,0,.181-.012,4.63,4.63,0,0,0,1.44-2.8,3.419,3.419,0,0,0-.881-2.264,4.148,4.148,0,0,0,1.5-2.586,2.639,2.639,0,0,0-1.272-2.132,2.931,2.931,0,0,0,1.513-2.237,3.183,3.183,0,0,0-1.363-2.35c.083-.051.163-.1.232-.145.8-.521,2.527-1.12,2.789-3.108A2.392,2.392,0,0,0,59.8,25.083ZM57.688,42.559a5.332,5.332,0,0,1-.6,2.26,5.492,5.492,0,0,1-.587-2.26,1.842,1.842,0,0,1,.59-1.3v0A1.828,1.828,0,0,1,57.688,42.559Zm.424-4.805a2.537,2.537,0,0,1-1.06,1.776A2.558,2.558,0,0,1,56,37.754c0-.524.459-.941,1.047-1.363C57.653,36.813,58.112,37.23,58.112,37.754Zm.193-4.369c.019.55-.551,1.014-1.256,1.507-.688-.493-1.259-.957-1.24-1.507.023-.63.607-1.157,1.251-1.591C57.706,32.228,58.282,32.755,58.3,33.385Z",
    transform: "translate(-40.155 -17.199)",
    fill: "#0072ce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M80.514,18.787a1.814,1.814,0,0,0,.178-.557s-1.669.164-2.669.164c-1.262,0-1.878.014-2.193.017a.485.485,0,0,0-.541.537c.02.363.567.482.567.482-.53.03-.592.03-1.288.022s-1.156.005-1.322.008a.433.433,0,0,0-.448.493c0,.326.464.433.464.433s-.372.03-.9.031a2.668,2.668,0,0,0-.832.1c-.14.056-.354.162-.332.414.034.522.538.462.629.462a10.208,10.208,0,0,0,2.183-.157,1.583,1.583,0,0,0,.819-.692s.525-.027,1.115-.044a3,3,0,0,0,1.239-.254,1.54,1.54,0,0,0,.494-.741s.582,0,1.53-.088C80.405,19.3,80.514,18.787,80.514,18.787Z",
    transform: "translate(-50.064 -13.501)",
    fill: "#0072ce"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M60.3,3.672a1.627,1.627,0,0,0,.974-1.5A1.693,1.693,0,0,0,59.1.532a1.646,1.646,0,0,0-.992.941,1.729,1.729,0,0,0,.819,2.2V8.281a.634.634,0,0,0,.672.658c.621,0,.7-.419.7-.645Z",
    transform: "translate(-31.451 -0.254)",
    fill: "#0072ce"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6",
    transform: "translate(93.992 10.639)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M206.54,24.152h.516a.392.392,0,0,1,.248.075.253.253,0,0,1,.1.218.319.319,0,0,1-.094.235.377.377,0,0,1-.282.1h-.487Zm.795.779a.47.47,0,0,0,.273-.194.525.525,0,0,0,.087-.287.517.517,0,0,0-.158-.366.642.642,0,0,0-.481-.165h-.792v1.875h.276V25h.515l.362.8h.306Zm.6.9a1.376,1.376,0,1,1,.408-.977,1.332,1.332,0,0,1-.408.977m.162-2.115a1.6,1.6,0,1,0,.475,1.138,1.551,1.551,0,0,0-.475-1.138",
    transform: "translate(-205.35 -23.243)",
    fill: "#0072ce"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdecLogo);
export default __webpack_public_path__ + "static/media/adec-logo.823dd07f83745e87a8f3765dde0d26af.svg";
export { ForwardRef as ReactComponent };